import { defineStore } from 'pinia'

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    active: false,
    content: '',
    color: '',
    bgColor: '',
    icon: '',
    duration: 3000
  }),

  getters: {
    getSnackBarData: (state) => state
  },

  actions: {
    updateSnackbar(data) {
      this.active = data.active
      this.content = data.content || ''
      this.color = data.color || ''
      this.bgColor = data.bgColor || ''
      this.icon = data.icon || ''
      this.duration = data.duration || 3000
    },
    closeSnackbar() {
      this.active = false
    }
  }
}) 